import Dict from '@/utils/dict-utils'
import DateUtils from '@/utils/date'
import dayjs from 'dayjs'

export const quickDateDict = new Dict({
  ALL: {
    label: '全部',
    value: 0,
    dayRange: []
  },
  ONE_YEAR: {
    label: '今年',
    value: 1,
    dayRange: [
      DateUtils.format(
        new Date(dayjs().startOf('year')),
        'yyyy-MM-dd HH:mm:ss'
      ),
      DateUtils.format(new Date(dayjs().endOf('date')), 'yyyy-MM-dd HH:mm:ss')
    ]
  },
  SIX_MONTH: {
    label: '近6月',
    value: 2,
    dayRange: [
      DateUtils.format(
        new Date(
          dayjs()
            .subtract(6, 'month')
            .startOf('date')
        ),
        'yyyy-MM-dd HH:mm:ss'
      ),
      DateUtils.format(new Date(dayjs().endOf('date')), 'yyyy-MM-dd HH:mm:ss')
    ]
  },
  THREE_MONTH: {
    label: '近3月',
    value: 3,
    dayRange: [
      DateUtils.format(
        new Date(
          dayjs()
            .subtract(3, 'month')
            .startOf('date')
        ),
        'yyyy-MM-dd HH:mm:ss'
      ),
      DateUtils.format(new Date(dayjs().endOf('date')), 'yyyy-MM-dd HH:mm:ss')
    ]
  },
  ONE_MONTH: {
    label: '近1月',
    value: 4,
    dayRange: [
      DateUtils.format(
        new Date(
          dayjs()
            .subtract(1, 'month')
            .startOf('date')
        ),
        'yyyy-MM-dd HH:mm:ss'
      ),
      DateUtils.format(new Date(dayjs().endOf('date')), 'yyyy-MM-dd HH:mm:ss')
    ]
  },
  CUSTOM: {
    label: '自定义',
    value: 5,
    dayRange: []
  }
})
